import useRebrandVersion from 'hooks/useRebrandVersion'
import type { _BaseButtonKind, _BaseButtonVariant } from 'LuxKit/Button/BaseButton'

/** Overlay buttons use primary only when the rebrand palette is active. */
export function useRebrandOverlayButtonKind(): _BaseButtonKind {
  return useRebrandVersion() === 'rebrand' ? 'primary' : 'secondary'
}

export function useRebrandOverlayBookmarkProps(): {
  iconKind: _BaseButtonKind | undefined
  iconVariant: _BaseButtonVariant | undefined
} {
  const isRebrand = useRebrandVersion() === 'rebrand'

  return {
    iconKind: isRebrand ? 'primary' : undefined,
    iconVariant: isRebrand ? 'dark' : undefined,
  }
}
